import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GlobalNotificationService } from '../Services/GlobalNotificationService';

import { GlobalNotificationType } from '../Models/GlobalNotificationType';

@Component({
    selector: 'globalnotification',
    styles: [
        `
            .notification {
                width: auto;
                z-index: 100;
                border: 1px solid rgba(0, 0, 0, 0.08);
                border-top: 0px;
            }

            .notification-error {
                background-color: #ffdddd;
            }

            .notification-warning {
                background-color: #efe3a9;
            }

            .notification-hint {
                background-color: #e3eafc;
            }

            .notification-body {
                display: flex;
                z-index: 2;
                position: relative;
            }

            .notification-body img.notification-img {
                flex: 0 0 auto;
                height: 100%;
                width: 25px;
                padding: 8px;
            }

            .notification-hint .notification-body img.notification-img {
                padding: 12px 8px;
            }

            .notification-body span.notification-text {
                flex: 1;
                line-height: 22px;
                height: 100%;
                padding: 10px 0px;
            }

            ::ng-deep .notification-body span.notification-text ul,
            ::ng-deep .notification-body span.notification-text ol {
                margin-left: 1.2rem;
            }

            .notification-body span.notification-close {
                flex: 0 0 auto;
                padding: 5px;
            }
        `,
    ],
    template: `
        @if (displayNotification) {
            <div
                class="notification"
                [ngClass]="{
                    'notification-error':
                        notification.Type == notificationTypes.Error,
                    'notification-warning':
                        notification.Type == notificationTypes.Warning,
                    'notification-hint':
                        notification.Type == notificationTypes.Hint,
                }"
            >
                <div class="notification-body">
                    <img
                        class="notification-img"
                        [src]="getNotificationIcon(notification.Type)"
                    />
                    <span
                        class="notification-text"
                        [innerHtml]="notification.Message"
                    >
                    </span>
                    <span
                        class="notification-close"
                        (click)="dismissNotification()"
                    >
                        <controlbar
                            [canMinimize]="false"
                            [canMaximize]="false"
                            (close)="dismissNotification()"
                        ></controlbar>
                    </span>
                </div>
            </div>
        }
    `,
    providers: [GlobalNotificationService],
    standalone: false,
})
export class GlobalNotification implements OnInit, OnDestroy {
    private _globalNotification = inject(GlobalNotificationService);

    notification: any = {};
    notificationTypes = GlobalNotificationType;

    now: Date = new Date();

    private _onDestroy: Subject<boolean> = new Subject<boolean>();

    get displayNotification(): boolean {
        return (
            this.notification &&
            this.notification.IsEmpty == false &&
            this.notification.Dismissed == false &&
            (this.notification.ShowNow == true ||
                new Date(this.notification.StartDate) <= this.now) &&
            (this.notification.EndDate == null ||
                this.notification.EndDate.trim().length == 0 ||
                new Date(this.notification.EndDate) > this.now)
        );
    }

    ngOnInit() {
        this.getNotification();
    }

    getNotificationIcon(type: number) {
        return this._globalNotification.getIcon(type);
    }

    getNotification() {
        this._globalNotification
            .getNotification()
            .pipe(takeUntil(this._onDestroy))
            .subscribe(
                (res) => {
                    this.notification = res;
                },
                (_err) => {},
            );
    }

    dismissNotification() {
        this.notification.Dismissed = true;
        this._globalNotification.dismissNotification();
    }

    ngOnDestroy() {
        this._onDestroy.next(true);
        this._onDestroy.complete();
    }
}
